// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:18
import { ServiceResourceSector_abstract } from './../abstract/SagaSchema/ServiceResourceSector_abstract';
export class ServiceResourceSector extends ServiceResourceSector_abstract {}
